<template>
<div @mouseleave="allmouseLeave">
	<div class="framecon" v-if="mouseIfshow">
		<div v-for="(items,index) in shoulist" :key="index">
			<div class="framecar" :style="index == mouseIndex ?'border: 1px solid #ededed;background: #ffffff':''"
			@mouseover="mouseOver(index)" @mouseleave="mouseLeave(index)">
				<div class="framecarson" v-if="index == mouseIndex">
					<div v-for="(item,k) in items.children" :key="k"
					:class="navId == item.id?'textcar_cur':'textcar'" @click="changeindex(item)">
						{{item.name}}
					</div>
				</div>
			</div>

		</div>
	</div>

  <div class="headerview">
	<div v-for="(item,index) in topList" :key="index" class="block_car" @click="blockBtn(item.pathurl)"
	 @mouseover="mouseOver(index)" >
		<img :src="item.imgurl" alt="" />
		<!-- <img src="../../static/index/shouye@2x.png" alt=""/> -->
		<span>{{item.title}}</span>
	</div>

  </div>

  <div class="con_one_img">
	    <!-- <div style="color:#E61F26;font-weight:bold;font-size:0.29rem;padding-top:0.5rem;margin-left:2rem;">少先队网络服务平台</div> -->
		<!-- <img src="../../static/index/topback@2x.png" alt=""/> -->
  </div>

 </div>
</template>

<script>

export default {
  components: {

  },

  data() {
		return {
			topList:[{
				title:"首页",
				pathurl:"/",
				imgurl:require("../../static/index/shouye@2x.png")
			},{
			    title:"红领巾通讯社",
				pathurl:"/scarfnewsagencyIndex",
				imgurl:require("../../static/index/youthservices@2x.png")
			},{
				title:"专题活动",
				pathurl:"/pressrelease",
				imgurl:require("../../static/index/special@2x.png")
			},{
				title:"网络课堂",
				pathurl:"/networkclassroomIndex",
				imgurl:require("../../static/index/qualityclass@2x.png")
			}],

			shoulist:[],
			navId:"",
			mouseIndex:0,
			mouseIfshow:false,

		};
  },

  mounted() {
	    this.navId = sessionStorage.getItem("navId")
		this.getNavigation()
  },

  methods: {
	  getNavigation(){
		  console.log(1111111111111111)

		  this.$get(`web/navigation/getList?type=0`).then(res=>{
				  if(res.success){
					   console.log(res.result)
					   this.shoulist = res.result;
					   this.topList = []
					   for(var i =0;i<res.result.length;i++){
						   var jsonv = {}
						   jsonv.title = res.result[i].name
						   jsonv.pathurl = res.result[i].chainedAddress
						   if(i == 0){
							    jsonv.imgurl = require("../../static/index/shouye@2x.png")
						   }else if(i == 1){
							    jsonv.imgurl = require("../../static/index/youthservices@2x.png")
						   }else if(i == 2){
							    jsonv.imgurl = require("../../static/index/special@2x.png")
						   }else if(i == 3){
							    jsonv.imgurl = require("../../static/index/qualityclass@2x.png")
						   }
						   this.topList.push(jsonv);
					   }
				  }
			})
	  },

	  //鼠标移入移出
	  mouseOver(index){
		  this.mouseIndex = index;
		  this.mouseIfshow = true;
	  },
	  mouseLeave(index){
		  this.mouseIndex = index;
		  this.mouseIfshow = false;
	  },
	  allmouseLeave(){
		  this.mouseIfshow = false;
	  },

	  //变化跳转（子）
	  changeindex(item){
		  // console.log(item.id)
		  sessionStorage.setItem("navId", item.id)
		  this.navId = item.id

		  // debugger
		  if(sessionStorage.getItem("chainedAddress") == item.chainedAddress){
			   this.$router.go(0)
		  }else{
			   this.$router.push({ path: item.chainedAddress });
		  }
		  // this.$router.push({ path: item.chainedAddress });
		  sessionStorage.setItem("chainedAddress", item.chainedAddress)
	  },

	  //变化跳转（父）
	  blockBtn(pathurl){
		  sessionStorage.setItem("navId", "")
		  // console.log(this.$route.path +" --------  "+pathurl);
		  // return;
		  if(this.$route.path == pathurl || (this.$route.path == "/pressrelease" && pathurl == "/pressrelease?type=3" && this.$route.query.type == "3")){
				this.$router.go(0)
		  }else{
				if(pathurl == '/pressrelease'){
					this.$router.push({ path: '/pressrelease', query: {type:3} });
					return;
				}
				this.$router.push({ path: pathurl });
		  }
		  // debugger
		  // if(pathurl == '/pressrelease'){
			 //  this.$router.push({ path: '/pressrelease', query: {type:3} });
			 //  return;
		  // }
		  // this.$router.push({ path: pathurl });
	  },


  },

};
</script>

<style scoped lang="scss">
	.headerview{
		height: 0.53rem;
		// border: 1px solid red;
		background: #E61F26;
		display: flex;
		align-items: center;
		justify-content: center;
		.block_car{
			// border: 1px solid #FFFFFF;
			width: 2.2rem;
			display: flex;
			align-items: center;
			justify-content: center;
			height: 0.53rem;
			line-height: 0.53rem;
			font-size: 0.16rem;
			color: #FFFFFF;
			font-weight: bold;
			cursor: pointer;
		}
		img{
			height: 0.22rem;
			width: 0.22rem;
			margin-right: 0.15rem;
			cursor: pointer;
		}

	}

	.con_one_img{
		margin: 0rem auto;
		width: 12.15rem;
		// border: 1px solid red;
		margin-top: 0.1rem;
		height: 1.4rem;
		background: url(../../static/index/topback@2x.png) no-repeat center / 100%;
	}

	.framecon{
		z-index: 100;
		margin-top: 0.53rem;
		position: absolute;
		display: flex;
		// align-items: center;
		justify-content: center;
		width: 100%;
	}
	.framecar{
		z-index: 100;
		height: auto;
		width: 1.5rem;
		margin-right: 0.2rem;
		// border: 1px solid #ededed;
		// background: #ffffff;
		padding: 0.2rem;
		cursor: pointer;
		.framecarson{
			height: 100%;
			// border-left: 0.03rem solid #E1E3E7;
			.textcar{
				padding-left: 0.1rem;
				font-size: 0.16rem;
				color:#666666;
				height: 0.35rem;
				line-height: 0.35rem;
				border-left: 0.03rem solid #E1E3E7;
			}
			.textcar_cur{
				padding-left: 0.1rem;
				font-size: 0.16rem;
				color:#666666;
				height: 0.35rem;
				line-height: 0.35rem;
				border-left: 0.03rem solid #E61F26;
				color:#E61F26;
				font-weight: 400;
			}
			.textcar:hover{ color:#E70012; border-left: 0.03rem solid #E61F26;}
		}
		.framecarson_cur{

		}

	}

</style>
